"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CheckboxGroup_1 = __importDefault(require("./CheckboxGroup"));
exports.default = CheckboxGroup_1.default;
